<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>


<form *ngIf="giftCardBrandForm" [formGroup]="giftCardBrandForm" (ngSubmit)="onSubmit(giftCardBrandForm)" class="content-card">
  <mat-card class="form-card" style="max-width: 1200px;">
    <mat-card-header>
      <mat-card-title>
        <div fxLayout="row" style="">
          <div fxFlex="30">
            <img src="{{brand.logoUrl}}" style="width: 100%; max-width: 140px; margin-right: 10px;" alt="Brand Logo" />
          </div>
          <div fxFlex="70">
            <h5>Brand<br />{{ brand?.name }}</h5>
            <div style="font-weight: normal; font-size: .7em; font-family: monospace">{{brand.slug}}</div>
          </div>
        </div>

        <div fxLayout="row" class="mt-1">

          <div fxFlex="100">
            <div style="font-weight: normal; font-size: .7em;">Gift card preview</div>
            <img src="{{brand.giftCardUrl}}" style="width: 100%; max-width: 140px; margin-right: 10px;" alt="Brand Logo" />
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>


      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="40">

          <div style="height: 30px;">
            <mat-checkbox formControlName="userIsEnabled">Enabled in App</mat-checkbox>
          </div>

          <div style="height: 40px;">
          <mat-form-field>
            <input matInput placeholder="User Discount" formControlName="userDiscount">
          </mat-form-field>
          </div>

          <div style="height: 40px;">
            <mat-form-field>
              <input matInput placeholder="Sort order" formControlName="sortOrder">
            </mat-form-field>
          </div>

          <mat-form-field>
            <mat-select placeholder="Category" formControlName="categoryId">
              <mat-option *ngFor="let template of brandCategories" [value]="template.id">{{template.nameEn}}</mat-option>
            </mat-select>
          </mat-form-field>


        </div>

      </div>


    </mat-card-content>

    <mat-card-actions align="end">
      <span style="display: inline-block; margin-right: 10px; cursor: pointer;" (click)="returnBack()">◀️ Go back</span> &nbsp;
      <button mat-raised-button color="primary" type="submit" [disabled]="!giftCardBrandForm.valid">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
